export default {
  domain: REPLACE_DOMAIN,
  campaignId: REPLACEWITHCAMPAIGNID,
  campaignDates: REPLACEWITHCAMPAIGNDATES,
  campaignType: REPLACEWITHCAMPAIGNTYPE,
  campaignCountry: REPLACEWITHCAMPAIGNCOUNTRY,
  campaignLocales: REPLACEWITHCAMPAIGNLOCALES?.split(','),
  campaignCurrency: REPLACEWITHCAMPAIGNCURRENCY,
  campaignConsumerFields: REPLACEWITHCAMPAIGNCONSUMERFIELDS,
  campaignUniverse: REPLACEWITHCAMPAIGNUNIVERSE,
  campaignPrizes: REPLACEWITHCAMPAIGNPRIZES,
  submissionUri: REPLACEWITHSUBMISSIONURI,
  maxRedemptions: REPLACE_MAX_REDEMPTIONS,
  timezone: REPLACE_TIMEZONE,
  version: REPLACE_VERSION,
}
